<section class="page-offset section-pad">
  <div class="container">
    <h1 class="fw-bold mb-4">{{ i18n.t('security.title') }}</h1>
    <div class="row g-4">
      <div class="col-md-6">
        <div class="soft-card bg-white p-4">
          <h2 class="h5">{{ i18n.t('security.mfaTitle') }}</h2>
          <p class="text-secondary">{{ i18n.t('security.mfaText') }}</p>
          <div class="alert alert-light border small" role="note">{{ i18n.t('security.mfaRecoveryHelp') }}</div>
          @if (isMfaEnabled && !mfaSecretCode) {
            <div class="alert alert-success small" role="status">{{ i18n.t('security.mfaEnabledSummary') }}</div>
          }
          <div class="mfa-actions d-flex flex-wrap gap-2 align-items-center">
            <button class="btn btn-primary" type="button" (click)="enableMfa()" [disabled]="isLoadingMfaStatus || isEnablingMfa || isConfirmingMfa" [attr.aria-busy]="isLoadingMfaStatus || isEnablingMfa">
              @if (isLoadingMfaStatus || isEnablingMfa) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
              <span>{{ primaryMfaActionLabel }}</span>
            </button>
            <button class="btn btn-outline-danger" type="button" (click)="disableMfa()" [disabled]="isLoadingMfaStatus || isDisablingMfa || isConfirmingMfa || (!isMfaEnabled && !mfaSecretCode)" [attr.aria-busy]="isDisablingMfa">
              @if (isDisablingMfa) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
              <span>{{ isDisablingMfa ? i18n.t('security.disablingMfa') : i18n.t('security.disableMfa') }}</span>
            </button>
          </div>
          @if (mfaSecretCode) {
            <div class="mt-3 border rounded-4 p-3 bg-light">
              <p class="fw-semibold mb-2">{{ i18n.t('security.mfaScanQr') }}</p>
              @if (mfaQrCodeDataUrl) {
                <img class="d-block bg-white border rounded-3 p-2" width="220" height="220" [src]="mfaQrCodeDataUrl" [alt]="i18n.t('security.mfaQrAlt')">
              }
              <p class="small text-secondary mt-2 mb-0">{{ i18n.t('security.mfaScanHelp') }}</p>
              <details class="mt-3">
                <summary class="small fw-semibold text-primary">{{ i18n.t('security.mfaCannotScan') }}</summary>
                <div class="mt-2">
                  <label class="form-label" for="mfaSecretCode">{{ i18n.t('security.mfaSecretCode') }}</label>
                  <input id="mfaSecretCode" class="form-control font-monospace" type="text" [value]="mfaSecretCode" readonly>
                  <p class="small text-secondary mt-2 mb-0">{{ i18n.t('security.mfaSecretHelp') }}</p>
                </div>
              </details>
            </div>
            <form class="row g-2 mt-3" (ngSubmit)="confirmMfa()">
              <div class="col-12"><p class="required-fields-notice text-secondary small bg-light rounded-3 p-3 mb-0">{{ i18n.t('common.requiredFieldsNotice') }}</p></div>
              <div class="col-12"><label class="form-label" for="mfaVerificationCode">{{ i18n.t('security.mfaVerificationCode') }}<span class="required-star" aria-hidden="true">*</span></label><input id="mfaVerificationCode" class="form-control" name="mfaVerificationCode" [(ngModel)]="mfaVerificationCode" autocomplete="one-time-code" required [disabled]="isConfirmingMfa"></div>
              <div class="col-12"><button class="btn btn-outline-primary" type="submit" [disabled]="isConfirmingMfa" [attr.aria-busy]="isConfirmingMfa">
                @if (isConfirmingMfa) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
                <span>{{ isConfirmingMfa ? i18n.t('security.confirmingMfa') : i18n.t('security.confirmMfa') }}</span>
              </button></div>
            </form>
          }
          @if (mfaStatusKey) { <div class="alert alert-info mt-3 mb-0">{{ i18n.t(mfaStatusKey) }}</div> }
        </div>
      </div>
      <div class="col-md-6">
        <div class="soft-card bg-white p-4">
          <h2 class="h5">{{ i18n.t('security.passwordTitle') }}</h2>
          <p class="text-secondary">{{ i18n.t('security.passwordText') }}</p>
          <div class="alert alert-light border small" role="note">{{ i18n.t('security.passwordResetRecoveryHelp') }}</div>
          <button class="btn btn-outline-primary" type="button" (click)="resetPassword()" [disabled]="isRequestingPasswordReset" [attr.aria-busy]="isRequestingPasswordReset">
            @if (isRequestingPasswordReset) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
            <span>{{ isRequestingPasswordReset ? i18n.t('security.requestingPasswordReset') : i18n.t('security.resetPassword') }}</span>
          </button>
          <form class="row g-2 mt-3" (ngSubmit)="confirmPasswordReset()">
            <div class="col-12"><p class="required-fields-notice text-secondary small bg-light rounded-3 p-3 mb-0">{{ i18n.t('common.requiredFieldsNotice') }}</p></div>
            <div class="col-12"><label class="form-label" for="passwordResetCode">{{ i18n.t('security.resetCode') }}<span class="required-star" aria-hidden="true">*</span></label><input id="passwordResetCode" class="form-control" name="resetCode" [(ngModel)]="resetCode" autocomplete="one-time-code" required [disabled]="isConfirmingPasswordReset"></div>
            <div class="col-12"><label class="form-label" for="newPassword">{{ i18n.t('security.newPassword') }}<span class="required-star" aria-hidden="true">*</span></label><input id="newPassword" class="form-control" type="password" name="newPassword" [(ngModel)]="newPassword" autocomplete="new-password" required [disabled]="isConfirmingPasswordReset"></div>
            <div class="col-12"><button class="btn btn-primary" type="submit" [disabled]="isConfirmingPasswordReset" [attr.aria-busy]="isConfirmingPasswordReset">
              @if (isConfirmingPasswordReset) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
              <span>{{ isConfirmingPasswordReset ? i18n.t('security.confirmingPasswordReset') : i18n.t('security.confirmPasswordReset') }}</span>
            </button></div>
          </form>
          @if (passwordResetStatusKey) { <div class="alert alert-info mt-3 mb-0">{{ i18n.t(passwordResetStatusKey) }}</div> }
        </div>
      </div>
      @if (isOrcidEnabled) {
        <div class="col-md-6">
        <div class="soft-card bg-white p-4">
          <h2 class="h5">{{ i18n.t('security.orcidTitle') }}</h2>
          <p class="text-secondary">{{ i18n.t('security.orcidText') }}</p>
          @if (isOrcidLinked) {
            <div class="alert alert-success small" role="status">
              {{ i18n.t('security.orcidLinkedSummary') }}
              @if (safeOrcidUri) {
                <a class="ms-2" [href]="safeOrcidUri" target="_blank" rel="noopener noreferrer">{{ orcidId }}</a>
              } @else {
                <span class="ms-2">{{ orcidId }}</span>
              }
            </div>
          } @else {
            <div class="alert alert-light border small" role="note">{{ i18n.t('security.orcidNotLinkedSummary') }}</div>
          }
          <div class="d-flex flex-wrap gap-2 align-items-center">
            <button class="btn btn-primary" type="button" (click)="linkOrcid()" [disabled]="isLinkingOrcid || isOrcidLinked" [attr.aria-busy]="isLinkingOrcid">
              @if (isLinkingOrcid) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
              <span>{{ isLinkingOrcid ? i18n.t('security.linkingOrcid') : i18n.t('security.linkOrcid') }}</span>
            </button>
            <button class="btn btn-outline-danger" type="button" (click)="unlinkOrcid()" [disabled]="isUnlinkingOrcid || !isOrcidLinked" [attr.aria-busy]="isUnlinkingOrcid">
              @if (isUnlinkingOrcid) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
              <span>{{ isUnlinkingOrcid ? i18n.t('security.unlinkingOrcid') : i18n.t('security.unlinkOrcid') }}</span>
            </button>
          </div>
          @if (orcidStatusKey) { <div class="alert alert-info mt-3 mb-0">{{ i18n.t(orcidStatusKey) }}</div> }
        </div>
        </div>
      }
    </div>
  </div>
</section>
